<template>
  <div class="chat-container">
    <div
      id="chat-circle"
      class="btn btn-raised"
      :class="{ 'hidden-circle': isOpen }"
      @click="toggleChat"
      title="Converse com a Cila!"
      style="z-index: 1000;"
    >
      <div id="chat-overlay"></div>
      <img class="iconWidget" src="@/assets/imgs/chat_ia/instituto.png">
    </div>

    <div id="myChatBox" class="chat-box chat" :class="{ 'mostrar-chat': isOpen, 'chat-expandido': isExpanded }">
      <div class="chat-box-header chat">
        <img style="width: 35px; margin-top: -16px;" src="@/assets/imgs/chat_ia/instituto.png">
        <span class="chat-box-expand" @click.stop="toggleExpand" :title="isExpanded ? 'Recolher' : 'Expandir'">
          <i :class="isExpanded ? 'fas fa-compress-alt' : 'fas fa-expand-alt'"></i>
        </span>
        <span class="chat-box-toggle" @click.stop="toggleChat">
          <img class="send-icon" style="width: 20px; cursor: pointer;" src="@/assets/imgs/chat_ia/fechar.png">
        </span>
      </div>

      <div class="chat-box-body">
        <div class="chat-box-overlay"></div>
        <div class="chat-logs" id="chat-logs">

          <div class="mensagemInicial">
            <div class="talk-bubble tri-right left-top" style="width: 100%; margin-bottom: 30px">
              <div class="talktext">
                <div class="speak speak-option" style="border-radius: 20px;">
                  <div class="options" style="padding:15px">
                    <span>Oi! Eu sou a Cila, a inteligência artificial do IEPTB-BR, e estou aqui pra te ajudar.</span>
                  </div>
                  <br>
                  <div class="options">
                    <input type="button" title="Veja como fazer para protestar" value="Como faço um protesto?" class="input-option" @click="perguntar('Como faço um protesto?')">
                    <input type="button" title="Quero cancelar um protesto, como faço?" value="Como faço para cancelar um protesto?" class="input-option" @click="perguntar('Como faço para cancelar um protesto?')">
                    <input type="button" title="Quero fazer uma Certidão" value="Como faço uma Certidão?" class="input-option" @click="perguntar('Como faço uma Certidão?')">
                    <input type="button" title="Quero fazer uma anuência" value="Como faço uma Anuência?" class="input-option" @click="perguntar('Como faço uma Anuência?')">
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-for="(msg, index) in messages" :key="index">

            <div v-if="msg.type === 'me'" class="chat-msg user">
              <p class="me">{{ msg.text }}</p>
            </div>

            <div v-else class="chat-msg">
              <span class="msg-avatar" style="width: 100%; position: relative;">
                <div class="posicao-avat" style="float: left; width: 100%; position: relative; padding: 20px 0; left: 0;">
                  <div class="them" v-html="msg.html"></div>
                </div>
              </span>
            </div>

          </div>

          <span v-if="isTyping" class="msg-avatar" style="width: 100%; position: relative;">
            <div class="posicao-avat" style="float: left; width: 100%; position: relative; left: 0;">
              <p class="them" style="width: 100%; left: 30px; height: 50px;">
                <span class="load-3" style="color: #004e86 !important;">
                  <span class="line"></span>
                  <span class="line"></span>
                  <span class="line"></span>
                </span>
              </p>
            </div>
          </span>

        </div>
      </div>

      <div class="chat-input">
        <form @submit.prevent="handleSend" class="chat-form">
          <input
            type="text"
            v-model="userInput"
            placeholder="Enviar uma mensagem..."
            class="custom-input"
          />
          <button type="submit" class="chat-submit">
            <img class="send-icon" src="@/assets/imgs/chat_ia/paper-plane.png">
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOpen: false,
      isExpanded: false,
      userInput: '',
      messages: [],
      isTyping: false,
      params: {
        cd_usuario: 0,
        cd_questao_anterior: 0,
        qtd_params: 0,
        nm_protocolo: 0,
        nm_audio: '0'
      }
    };
  },

  mounted() {
    window.perguntar = this.perguntar;
  },

  methods: {
    async ajustarScroll() {
      await this.$nextTick();
      const objDiv = document.getElementById("chat-logs");
      if (objDiv) objDiv.scrollTop = objDiv.scrollHeight;
    },

    formatarPergunta(txt) {
      return txt.normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/[^a-zA-Z0-9@,.;:!\-\s]/g, '')
        .split(',-1').join('');
    },

    async perguntar(perguntaTexto) {
      if (!perguntaTexto || String(perguntaTexto).trim() === '') return;

      this.messages.push({ type: 'me', text: perguntaTexto });

      const questionSend = this.formatarPergunta(String(perguntaTexto));
      this.userInput = '';
      this.isTyping = true;
      await this.ajustarScroll();

      const url = `https://homolog.chat.cenprotnacional.org.br/api/v1/perguntas/questao/${this.params.nm_protocolo}/${this.params.cd_usuario}/${this.params.cd_questao_anterior}/${encodeURIComponent(questionSend)}/${this.params.qtd_params}/${this.params.nm_audio}`;

      try {
        const response = await fetch(url, {
          method: 'GET',
          mode: 'cors'
        });

        if (response.ok) {
          const data = await response.json();
          if (data && data.length > 0) {
            const result = data[0];
            this.params.cd_questao_anterior = result.cd_questao_anterior;
            this.params.qtd_params = result.qtd_params_query_1;
            this.params.nm_audio = result.nm_audio;
            this.messages.push({ type: 'cila', html: result.output });
          }
        }
      } catch (error) {
        console.error("Erro ao consultar API:", error);
        this.messages.push({ type: 'cila', text: "Desculpe, tive um problema ao processar sua resposta." });
      } finally {
        this.isTyping = false;
        await this.ajustarScroll();
      }
    },

    toggleChat() {
      this.isOpen = !this.isOpen;
      if (!this.isOpen) this.isExpanded = false;
      const chatElement = document.getElementById('myChatBox');
      if (chatElement) {
        chatElement.classList.toggle('mostrar-chat', this.isOpen);
      }
    },

    toggleExpand() {
      this.isExpanded = !this.isExpanded;
      this.ajustarScroll();
    },

    handleSend() {
      this.perguntar(this.userInput);
    }
  }
};
</script>


<style scoped>
@import "~@/assets/css/chat_ia/style.css";
@import "~@/assets/css/chat_ia/style_loading.css";



/* Quando o chat abre, o círculo encolhe e some */
#chat-circle.hidden-circle {
  opacity: 0;
  transform: scale(0);
  visibility: hidden;
  pointer-events: none;
}

/* --- CAIXA DE DIALOGO --- */
.chat-box {
  display: flex !important;
  flex-direction: column;
  position: fixed;
  bottom: 20px;
  right: 20px;

  opacity: 0;
  visibility: hidden;
  pointer-events: none;

  /* Efeito de subir e expandir */
  transform: translateY(40px) scale(0.8);
  transform-origin: bottom right;
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 2001;
}

.chat-box.mostrar-chat {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transform: translateY(0) scale(1);
}

/* Container que segura o formulário */
.chat-input {
  background: #fff;
  padding: 15px;
  border-top: 1px solid #eee;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}

/* Formulário ocupando 100% e posicionando o botão */
.chat-form {
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
}

/* O Input Estiloso */
.custom-input {
  width: 100%;
  background: #f4f7f9;
  border: 1px solid #e0e0e0;
  border-radius: 25px;
  padding: 12px 50px 12px 20px;
  font-size: 14px;
  color: #333;
  transition: all 0.3s ease;
  outline: none;
}

/* Efeito ao clicar/focar no campo */
.custom-input:focus {
  background: #fff;
  border-color: #004a8d;
  box-shadow: 0 4px 10px rgba(0, 74, 141, 0.1);
}

/* Ajuste do Botão de Enviar para ficar dentro do input */
.chat-submit {
  position: absolute;
  right: 10px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
}

.chat-submit:hover {
  transform: scale(1.1);
}

.chat-submit img {
  width: 20px;
  height: 20px;
  opacity: 0.7;
}

.chat-submit:hover img {
  opacity: 1;
}

/* Estilização do Placeholder (o texto cinza) */
.custom-input::placeholder {
  color: #a0a0a0;
  font-style: italic;
  font-size: 13px;
}

/* Neutraliza o line-height global do App.vue que vaza para o chat */
.chat-box p,
.chat-box span,
.chat-box div {
  line-height: 1.4 !important;
  font-weight: 400 !important;
}

/* Botão expandir no header */
.chat-box-expand {
  float: right;
  margin-right: 10px;
  margin-top: -8px;
  cursor: pointer;
  color: #fff;
  font-size: 14px;
  opacity: 0.85;
  transition: opacity 0.2s ease;
}

.chat-box-expand:hover {
  opacity: 1;
}

/* Estado expandido — ocupa quase a tela toda verticalmente */
.chat-box.chat-expandido {
  bottom: 10px !important;
  top: 10px !important;
  height: calc(100vh - 20px) !important;
}

.chat-box.chat-expandido .chat-box-body {
  flex: 1;
  overflow: hidden;
}

.chat-box.chat-expandido .chat-logs {
  height: calc(100vh - 160px) !important;
}
</style>
